module.exports = __webpack_public_path__ + "img/heart-hand.c0ce1666.svg";